import React from 'react'
import { Badge } from 'react-bootstrap'

const MemberStatusBadge = ({ member }) => {

    const getStatusColor = () => {
        let statusColor = '';
        if (member.archivedByAdmin === '1') {
            statusColor = 'secondary'
        } else if (member.blockedByAdmin === '1') {
            statusColor = 'danger'
        } else if (member.expiryStatus === 'membershipIsExpired') {
            statusColor = 'red'
        } else if (member.expiryStatus === 'membershipIsExpiringSoon') {
            statusColor = 'primary'
        } else if (member.expiryStatus === 'membershipIsInTolerancePeriod') {
            statusColor = 'info'
        } else if (member.status === 'EmailVerificationRequired') {
            statusColor = 'info'
        } else if (member.status === 'SignupRequest') {
            statusColor = 'warning'
        } else if (member.status === 'SignupRequestRejected') {
            statusColor = 'danger'
        } else if (member.status === 'RegistrationPaymentPending') {
            statusColor = 'info'
        }
        return statusColor;
    }

    const getStatusMsg = () => {
        let statusMsg = '';

        if (member.archivedByAdmin === '1') {
            statusMsg = 'Membership Archived By Admin'
        } else if (member.blockedByAdmin === '1') {
            statusMsg = 'Membership Blocked By Admin'
        } else if (member.expiryStatus === 'membershipIsExpired') {
            statusMsg = 'Membership Expired'
        } else if (member.expiryStatus === 'membershipIsExpiringSoon') {
            statusMsg = 'Membership Expiring Soon'
        } else if (member.expiryStatus === 'membershipIsInTolerancePeriod') {
            statusMsg = 'Membership Is In Tolerance Period'
        } else if (member.status === 'EmailVerificationRequired') {
            statusMsg = 'Signup Request - Email Verification Required'
        } else if (member.status === 'SignupRequest') {
            statusMsg = 'Signup Request - Admin Action Required'
        } else if (member.status === 'SignupRequestRejected') {
            statusMsg = 'Signup Request - Rejected'
        } else if (member.status === 'RegistrationPaymentPending') {
            statusMsg = 'Signup Request - Registration Payment Pending'
        }
        return statusMsg;
    }



    return (
        <>
            {getStatusMsg(member) && <div className={`memberStatusBadge ${getStatusColor(member)}`}>{getStatusMsg(member)}</div>}

            {(member.expiryStatus === 'membershipIsExpired' && member.clubAdminReactivated === '1') && <div className={`memberStatusBadge success`}>Reactivated By Club Admin</div>}
        </>

    )
}

export default MemberStatusBadge